import config from '@/v2/config';

export const API_URL = config.REACT_APP_API_URL;
export const RESET_STORE = 'RESET_STORE';
